var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{staticClass:"sf-header__logo",attrs:{"to":_vm.localePath('/')}},[_c('img',{staticClass:"logoheader",attrs:{"src":'/homepage/header/logo.png',"alt":'Mpex',"title":'Mpex',"width":189,"height":68}})])}
var staticRenderFns = []

export { render, staticRenderFns }